import { Icons } from "@pankod/refine-antd";
import { ResourceProps } from "@pankod/refine-core";
import { About } from "pages/about/about";
import { ArticleCreate, ArticleEdit, ArticleList, ArticleShow } from "pages/article";
import { AskTheExpert } from "pages/askexpert/askexpert";
import { AssessmentList } from "pages/assessment";
import { AssetCreate, AssetEdit, AssetList, AssetShow } from "pages/asset";
import { AllocationList } from "pages/associatemapping";
import { AllocationCreate } from "pages/associatemapping/create";
import { ContractEdit, ContractList } from "pages/contracts";
import { EngagementCreate, EngagementEdit, EngagementList, EngagementShow } from "pages/engagements";
import { EvaluationEdit, EvaluationList, EvaluationShow } from "pages/evaluation";
import { EvaluationModelList } from "pages/evaluationmodel/list";
import { EvaluationModelShow } from "pages/evaluationmodel/show";
import { EventCreate, EventEdit, EventList, EventShow } from "pages/events";
import { GroupCreate, GroupEdit, GroupList, GroupShow } from "pages/groups";
import { HeliumAIList } from "pages/helium-ai";
import { ChatList } from "pages/helium-ai/chat/list";
import { ABMDeskList, AnnouncementList, AspireList, SecurityInfoList } from "pages/infocorner";
import { PodcastList } from "pages/infocorner/podcast/list";
import { TagsReviewList } from "pages/manage/tags/list";
import { PeopleList, PeopleShow } from "pages/people";
import { ProfileEdit, ProfileList, Worklist } from "pages/profile";
import { Notifications } from "pages/profile/myNotifications";
import { CandidateCreate, CandidateEdit, CandidateEvaluationEdit, CandidateEvaluationShow, CandidateList, CandidateShow, CreateResourcingRequest, EditResourcingRequest, PositionEdit, PositionList, PositionShow, ResourcingRequestList, ResourcingRequestShow } from "pages/resourcing";
import { AvailabilityList } from "pages/spaces/availabilities/list";

import { ReservationCreate, ReservationEdit, ReservationList, ReservationShow } from "pages/spaces/reservations";
import { RoomCreate, RoomEdit, RoomList, RoomShow } from "pages/spaces/rooms";
import { SystemList } from "pages/system";
import { UserCreate, UserEdit, UserList, UserShow } from "pages/users";
import { RESOURCE_PATH } from "scripts/site";

import { ProcessList } from "pages/infocorner/process/list";
import { CountryCreate, CountryEdit, CountryList, CountryShow } from "pages/manage/country";
import { LocationCreate, LocationEdit, LocationList, LocationShow } from "pages/manage/location";

export const heliumResources: ResourceProps[] = [
    {
        name: "home",
        key: "home",
        options: { label: "Home" },
        icon: <Icons.HomeOutlined />
    },
    {
        name: RESOURCE_PATH.PROFILE,
        key: RESOURCE_PATH.PROFILE,
        list: ProfileList,
        edit: ProfileEdit,
        parentName: "home",
        options: { label: "My Profile" },
        icon: <Icons.AppstoreOutlined />
    },
    {
        name: RESOURCE_PATH.WORKLIST,
        key: RESOURCE_PATH.WORKLIST,
        parentName: "home",
        list: Worklist,
        options: { label: "My Worklist" },
        icon: <Icons.BellOutlined />
    },
    {
        name: RESOURCE_PATH.NOTIFICATIONS,
        key: RESOURCE_PATH.NOTIFICATIONS,
        parentName: "home",
        list: Notifications,
        options: { label: "My Notifications" },
        icon: <Icons.NotificationOutlined />
    },
    {
        name: "helium-stories",
        key: "helium-stories",
        options: { label: "Helium Stories" },
        icon: <Icons.BulbOutlined />
    },
    {
        name: RESOURCE_PATH.HELIUM_AI,
        key: RESOURCE_PATH.HELIUM_AI,
        list: HeliumAIList,
        parentName: "helium-stories",
        options: { label: "Helium AI" },
        icon: <Icons.FileTextOutlined />
    },
    {
        name: RESOURCE_PATH.CHAT,
        key: RESOURCE_PATH.CHAT,
        list: ChatList,
        parentName: "helium-stories",
        // options: { label: "Chat" },
        icon: <Icons.CommentOutlined />
    },
    {
        name: RESOURCE_PATH.PEOPLE,
        key: RESOURCE_PATH.PEOPLE,
        list: PeopleList,
        show: PeopleShow,
        canDelete: false,
        options: { label: "People" },
        icon: <Icons.TeamOutlined />
    },
    {
        name: RESOURCE_PATH.ASSET,
        key: RESOURCE_PATH.ASSET,
        list: AssetList,
        create: AssetCreate,
        edit: AssetEdit,
        show: AssetShow,
        canDelete: true,
        icon: <Icons.LaptopOutlined />
    },
    {
        name: "engagements",
        key: "engagements",
        options: { label: "Engagement" },
        icon: <Icons.GlobalOutlined />
    },
    {
        name: RESOURCE_PATH.ENGAGEMENTS,
        key: RESOURCE_PATH.ENGAGEMENTS,
        list: EngagementList,
        show: EngagementShow,
        create: EngagementCreate,
        edit: EngagementEdit,
        parentName: "engagements",
        canDelete: false,
        icon: <Icons.GlobalOutlined />
    },
    {
        name: RESOURCE_PATH.CONTRACT,
        key: RESOURCE_PATH.CONTRACT,
        list: ContractList,
        edit: ContractEdit,
        parentName: "engagements",
        canDelete: false,
        icon: <Icons.FileProtectOutlined />
    },
    {
        name: RESOURCE_PATH.ASSOCIATEMAPPING,
        key: RESOURCE_PATH.ASSOCIATEMAPPING,
        list: AllocationList,
        create: AllocationCreate,
        options: { label: "Associates" },
        parentName: "engagements",
        canDelete: false,
        icon: <Icons.SolutionOutlined />
    },
    {
        name: RESOURCE_PATH.ASSESSMENT,
        key: RESOURCE_PATH.ASSESSMENT,
        list: AssessmentList,
        parentName: "engagements",
        canDelete: false,
        icon: <Icons.FormOutlined />
    },
    {
        name: RESOURCE_PATH.EVALUATION,
        key: RESOURCE_PATH.EVALUATION,
        list: EvaluationList,
        edit: EvaluationEdit,
        show: EvaluationShow,
        parentName: "engagements",
        canDelete: true,
        icon: <Icons.ContainerOutlined />
    },
    {
        name: RESOURCE_PATH.EVALUATIONMODEL,
        key: RESOURCE_PATH.EVALUATIONMODEL,
        list: EvaluationModelList,
        show: EvaluationModelShow,
        options: { label: "Eval. Models" },
        parentName: "engagements",
        canDelete: false,
        icon: <Icons.FormOutlined />
    },
    {
        name: "resourcing",
        key: "resourcing",
        options: { label: "Resourcing Corner" },
        icon: <Icons.AimOutlined />
    },
    {
        name: RESOURCE_PATH.CANDIDATE,
        key: RESOURCE_PATH.CANDIDATE,
        create: CandidateCreate,
        edit: CandidateEdit,
        list: CandidateList,
        show: CandidateShow,
        parentName: "resourcing",
        options: { label: "Candidates" },
        icon: <Icons.UserSwitchOutlined />
    },
    {
        name: RESOURCE_PATH.CANDIDATEEVALUATION,
        key: RESOURCE_PATH.CANDIDATEEVALUATION,
        show: CandidateEvaluationShow,
        edit: CandidateEvaluationEdit,
        parentName: "resourcing",
        options: { label: "Candidate Evaluation" },
        icon: <Icons.UserSwitchOutlined />
    },
    {
        name: RESOURCE_PATH.RESOURCINGREQUEST,
        key: RESOURCE_PATH.RESOURCINGREQUEST,
        create: CreateResourcingRequest,
        edit: EditResourcingRequest,
        list: ResourcingRequestList,
        show: ResourcingRequestShow,
        parentName: "resourcing",
        options: { label: "Requests" },
        icon: <Icons.SkinOutlined />
    },
    {
        name: RESOURCE_PATH.POSITION,
        key: RESOURCE_PATH.POSITION,
        edit: PositionEdit,
        list: PositionList,
        show: PositionShow,
        parentName: "resourcing",
        options: { label: "Positions" },
        icon: <Icons.SolutionOutlined />
    },
    {
        name: RESOURCE_PATH.GROUPS,
        key: RESOURCE_PATH.GROUPS,
        options: { label: "Groups" },
        list: GroupList,
        create: GroupCreate,
        edit: GroupEdit,
        show: GroupShow,
        canDelete: true,
        icon: <Icons.GroupOutlined />
    },
    {
        name: "spaces",
        key: "spaces",
        options: { label: "Spaces" },
        icon: <Icons.CalendarOutlined />
    },
    {
        name: RESOURCE_PATH.ROOM,
        key: RESOURCE_PATH.ROOM,
        options: { label: "Rooms" },
        parentName: "spaces",
        list: RoomList,
        create: RoomCreate,
        edit: RoomEdit,
        show: RoomShow,
        canDelete: true,
        icon: <Icons.BorderOutlined />
    },
    {
        name: RESOURCE_PATH.RESERVATION,
        key: RESOURCE_PATH.RESERVATION,
        options: { label: "Reservations" },
        parentName: "spaces",
        list: ReservationList,
        create: ReservationCreate,
        edit: ReservationEdit,
        show: ReservationShow,
        canDelete: true,
        icon: <Icons.CarryOutOutlined />
    },
    {
        name: RESOURCE_PATH.AVAILABILITY,
        key: RESOURCE_PATH.AVAILABILITY,
        options: { label: "Availability" },
        parentName: "spaces",
        list: AvailabilityList,
        // show: ReservationShow,
        canDelete: false,
        icon: <Icons.CalendarOutlined />
    },
    {
        name: RESOURCE_PATH.EVENT,
        key: RESOURCE_PATH.EVENT,
        options: { label: "Events" },
        list: EventList,
        create: EventCreate,
        edit: EventEdit,
        show: EventShow,
        canDelete: true,
        icon: <Icons.ClusterOutlined />
    },
    {
        name: RESOURCE_PATH.ASKTHEEXPERT,
        key: RESOURCE_PATH.ASKTHEEXPERT,
        list: AskTheExpert,
        canDelete: false,
        options: { label: "Ask the Expert" },
        icon: <Icons.PhoneOutlined />
    },
    {
        name: "info-board",
        key: "info-board",
        options: { label: "Info Corner" },
        icon: <Icons.InfoCircleOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_PROCESS,
        key: RESOURCE_PATH.INFO_PROCESS,
        list: ProcessList,
        parentName: "info-board",
        options: { label: "Process" },
        icon: <Icons.ApartmentOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_ABMDESK,
        key: RESOURCE_PATH.INFO_ABMDESK,
        list: ABMDeskList,
        parentName: "info-board",
        options: { label: "ABM Desk" },
        icon: <Icons.CommentOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_ANNOUNCEMENTS,
        key: RESOURCE_PATH.INFO_ANNOUNCEMENTS,
        list: AnnouncementList,
        parentName: "info-board",
        options: { label: "Announcements" },
        icon: <Icons.SoundOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_ASPIRE,
        key: RESOURCE_PATH.INFO_ASPIRE,
        list: AspireList,
        parentName: "info-board",
        options: { label: "ASPIRE" },
        icon: <Icons.ReadOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_PODCAST,
        key: RESOURCE_PATH.INFO_PODCAST,
        list: PodcastList,
        parentName: "info-board",
        options: { label: "Podcasts" },
        icon: <Icons.AudioOutlined />
    },
    {
        name: RESOURCE_PATH.INFO_SECURITY,
        key: RESOURCE_PATH.INFO_SECURITY,
        list: SecurityInfoList,
        parentName: "info-board",
        options: { label: "Security" },
        icon: <Icons.SecurityScanOutlined />
    },
    {
        name: RESOURCE_PATH.ARTICLE,
        key: RESOURCE_PATH.ARTICLE,
        list: ArticleList,
        create: ArticleCreate,
        edit: ArticleEdit,
        show: ArticleShow,
        options: { label: "Articles" },
        icon: <Icons.BulbOutlined />
    },
    {
        name: "manage",
        key: "manage",
        options: { label: "Manage" },
        icon: <Icons.SettingOutlined />
    },
    {
        name: RESOURCE_PATH.REVIEW_TAGS,
        key: RESOURCE_PATH.REVIEW_TAGS,
        list: TagsReviewList,
        parentName: "manage",
        options: { label: "Review Tags" },
        canDelete: false,
        icon: <Icons.VerifiedOutlined />
    },
    {
        name: RESOURCE_PATH.USERS,
        key: RESOURCE_PATH.USERS,
        list: UserList,
        create: UserCreate,
        edit: UserEdit,
        show: UserShow,
        canDelete: true,
        parentName: "manage",
        icon: <Icons.TeamOutlined />
    },
    {
        name: RESOURCE_PATH.COUNTRY,
        key: RESOURCE_PATH.COUNTRY,
        list: CountryList,
        create: CountryCreate,
        edit: CountryEdit,
        show: CountryShow,
        canDelete: false,
        parentName: "manage",
        options: { label: "Countries" },
        icon: <Icons.PushpinOutlined />
    },
    {
        name: RESOURCE_PATH.LOCATION,
        key: RESOURCE_PATH.LOCATION,
        list: LocationList,
        create: LocationCreate,
        edit: LocationEdit,
        show: LocationShow,
        canDelete: false,
        parentName: "manage",
        options: { label: "Locations" },
        icon: <Icons.PushpinOutlined />
    },
    {
        name: RESOURCE_PATH.ABOUT,
        key: RESOURCE_PATH.ABOUT,
        list: About,
        canDelete: false,
        options: { label: "About" },
        icon: <Icons.InfoOutlined />
    },
    {
        name: RESOURCE_PATH.SYSTEM,
        key: RESOURCE_PATH.SYSTEM,
        list: SystemList,
        options: { label: "System" },
        canDelete: false,
        icon: <Icons.CodeOutlined />
    }
];